export default __webpack_public_path__ + "static/media/babaycorn.c3a48724.png";